import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import DriversGrid from './DriversGrid';
import DriversInsert from './DriversInsert';
import { IDriverState } from '../../types/stateTypes';
import { IDriverProps } from '../../types/propTypes';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Can } from '../../ability';
import { Common } from '../../utils/constants';
import StartChargePage from './StartChargePage';
import DriverActivitiesGrid from './DriverActivitiesGrid';
import DebtLetterHistoryGrid from './DebtLetterHistoryGrid';
import { companyNameReplace } from '../../utils';

export class Drivers extends Component<IDriverProps & WithTranslation, IDriverState> {
    state: IDriverState;
    constructor(props) {
        super(props);
        this.state = {
            showDriverDetailPage: true,
            driverId: null,
            showStartChargePage: false,
            showDriverActivitiesPage: false,
            showDebtHistoryPage: false,
            row: {},
            filterState: {
                rowsPerPage: 10,
                currentPage: 1,
                sortColumn: 'created_date',
                sortOrder: 'desc',
                offset: 0,
                searchForm: {
                    driver_email: '',
                    payment_card: '',
                    driver_name: '',
                    referral_code: '',
                    account_type: '',
                    payment_type: '',
                    organisation: '',
                    groups: [],
                    tags: [],
                    status: [
                        {
                            label: props.t('driver.label.enabled'),
                            value: Common.DriverStatus.ENABLE,
                        },
                    ],
                    promotion: [],
                    vehicle_number: '',
                    rfid_no: '',
                    address: '',
                },
            },
        };
    }
    toggleIsGridVisible = (toggle: boolean) => {
        this.setState({
            showDriverDetailPage: toggle,
            showStartChargePage: false,
            showDriverActivitiesPage: false,
            showDebtHistoryPage: false,
            driverId: null,
        });
    };
    editDriver = (id: number) => {
        this.setState({
            showDriverDetailPage: false,
            showStartChargePage: false,
            showDriverActivitiesPage: false,
            driverId: id,
        });
    };
    startChargePage = (id: number, row: any) => {
        this.setState({
            showDriverDetailPage: false,
            showStartChargePage: true,
            showDriverActivitiesPage: false,
            driverId: id,
            row: row,
        });
    };
    showDriverActivitiesPage = (row: any) => {
        this.setState({
            showDriverDetailPage: false,
            showStartChargePage: false,
            showDriverActivitiesPage: true,
            row: row,
        });
    };
    showDebtHistoryPage = (row: any) => {
        this.setState({
            showDebtHistoryPage: true,
            row: row,
        });
    };
    updateFilterState = (data, callBack: Function | null = null) => {
        this.setState({ ...this.state, filterState: { ...this.state.filterState, ...data } }, () => {
            if (callBack) {
                callBack();
            }
        });
    };
    render() {
        return (
            <>
                <Helmet>
                    <title>{companyNameReplace(this.props.t('driver.title'))}</title>
                </Helmet>
                {this.state.showDebtHistoryPage ? (
                    <DebtLetterHistoryGrid
                        t={this.props.t}
                        driverDetails={this.state.row}
                        toggleClosePage={() => this.toggleIsGridVisible(true)}
                    />
                ) : this.state.showDriverActivitiesPage ? (
                    <Can I={Common.Actions.VIEW_DRIVER_ACTIVITIES} a={Common.Modules.DRIVERS.ACCOUNTS}>
                        <DriverActivitiesGrid
                            t={this.props.t}
                            driverDetails={this.state.row}
                            toggleClosePage={() => this.toggleIsGridVisible(true)}
                        />
                    </Can>
                ) : this.state.showStartChargePage ? (
                    <Can I={Common.Actions.START_REMOTE_CHARGE} a={Common.Modules.DRIVERS.ACCOUNTS}>
                        <StartChargePage
                            t={this.props.t}
                            id={this.state.driverId!}
                            toggleClosePage={() => this.toggleIsGridVisible(true)}
                            driverDetails={this.state.row}
                        />
                    </Can>
                ) : this.state.showDriverDetailPage ? (
                    <Can I={Common.Actions.CAN_VIEW} a={Common.Modules.DRIVERS.ACCOUNTS}>
                        <DriversGrid
                            t={this.props.t}
                            toggleCloseDriversPage={() => this.toggleIsGridVisible(false)}
                            editDriver={this.editDriver}
                            startChargePage={this.startChargePage}
                            showDriverActivitiesPage={this.showDriverActivitiesPage}
                            showDebtLetterHistoryPage={this.showDebtHistoryPage}
                            updateFilterState={this.updateFilterState}
                            filterState={this.state.filterState}
                        />
                    </Can>
                ) : (
                    <DriversInsert
                        t={this.props.t}
                        id={this.state.driverId!}
                        toggleCloseDriversPage={() => this.toggleIsGridVisible(true)}
                    />
                )}
            </>
        );
    }
}

export default withTranslation()(Drivers);
